import React, { useEffect, useState, useMemo, useCallback } from 'react';

import ArchiveList from 'components/event/ArchiveList';
import {
  getArchivedTeamEvents,
  restoreEvent,
  startDuplicatingEvent,
  searchTeamEvents,
  clearTeamEventsSearchResults
} from 'actions/Event';
import { showModal } from 'actions';
import { ARCHIVED_EVENT_FILTERS } from 'constants/EventFilters';

import Paths from 'AppPaths';

import { matchPath } from 'react-router';
import { connect } from 'react-redux';

function Unconnected({
  getArchivedTeamEvents,
  startDuplicatingEvent,
  archivedEvents,
  restoreEvent,
  showModal,
  teamId,
  history,
  team,
  teamEventSearchResults,
  searchTeamEvents,
  isLoading
}) {
  const [currentPage, setCurrentPage] = useState(1);

  const { pageCount: totalPageCount, events } = useMemo(
    () => archivedEvents,
    [archivedEvents]
  );

  useEffect(() => {
    getArchivedTeamEvents(currentPage);
  }, [getArchivedTeamEvents, currentPage]);

  const loadNextEvents = useCallback(() => {
    setCurrentPage(prev => prev + 1);
  }, []);

  return (
    <ArchiveList
      team={team}
      onDuplicateClick={startDuplicatingEvent}
      onRestoreClick={restoreEvent}
      onDeleteClick={showModal.bind(null, 'EVENT_DELETE_FORM')}
      onViewClick={event => {
        history.push(`/dash/team/${teamId}/event/${event._id}/dashboard`);
      }}
      events={events}
      filter={ARCHIVED_EVENT_FILTERS}
      searchTeamEvents={searchTeamEvents}
      clearTeamEventsSearchResults={clearTeamEventsSearchResults}
      teamEventSearchResults={teamEventSearchResults}
      history={history}
      isLoading={isLoading}
      hasMoreEvents={currentPage < totalPageCount}
      loadNextEvents={loadNextEvents}
    />
  );
}

const PropMapper = (
  { archivedEvents, isEventLoading, team, teamEventSearchResults },
  { match }
) => {
  const teamMatch = matchPath(match.url, {
    path: Paths.TeamDash
  });

  const teamId = teamMatch ? teamMatch.params.teamId : null;

  return {
    archivedEvents,
    team,
    teamId,
    teamEventSearchResults,
    isLoading: isEventLoading
  };
};

export default connect(PropMapper, {
  getArchivedTeamEvents,
  restoreEvent,
  startDuplicatingEvent,
  showModal,
  searchTeamEvents,
  clearTeamEventsSearchResults
})(Unconnected);

export { Unconnected, PropMapper };
